import { useState } from "react";
import { Table } from "@/features/Table";
import { type S1DataUploadRow, s1_data_upload_columns } from "./columns";
import UploadPopover from "@/components/UploadPopover";
import { type FilterS1DataUploadSchema, S1DataUploadFilter } from "./filter";
import { S1DataUploadNew } from "./new";
import { useQueryClient } from "@tanstack/react-query";
import { Clients } from "@/lib/clients";
import { ClientTables } from "@/lib/clientTables";
import { useTranslation } from "react-i18next";

export const S1DataUploadTable = () => {
  const { t } = useTranslation("tables");
  const [files, setFiles] = useState<File[]>([]);
  const [selectedConfig, setSelectedConfig] = useState<string | null>(null);
  const client = Clients.S1;
  const table_name = `${ClientTables.S1_DATA_UPLOAD}`;

  const QueryClient = useQueryClient();
  const refreshList = async () => {
    await QueryClient.invalidateQueries({
      queryKey: [client, table_name, "get"],
    });
  };

  return (
    <Table<S1DataUploadRow, FilterS1DataUploadSchema>
      label={t(`${ClientTables.S1_DATA_UPLOAD}.title`, {
        defaultValue: "Data Upload",
      })}
      client={client}
      table_name={table_name}
      columns={s1_data_upload_columns}
      filter={<S1DataUploadFilter />}
      disable_translations_request={true}
      new_item={
        <UploadPopover
          uploader={({ setIsOpen }) => (
            <S1DataUploadNew
              setIsOpen={setIsOpen}
              files={files}
              setFiles={setFiles}
              selectedConfig={selectedConfig}
              setSelectedConfig={setSelectedConfig}
              onSuccess={async () => {
                await refreshList();
              }}
            />
          )}
        />
      }
    />
  );
};
